import { Component, ViewEncapsulation } from '@angular/core';
import { ProjectSpecificationsComponent } from '../project-specifications/project-specifications.component';

/**
 * V3 Project tray panel. Vertical stack of the same editable fields V2 exposes
 * in the procurement-layout spec row, scoped to the ribbon tray. Extends
 * ProjectSpecificationsComponent so it inherits projectCopy / updateProject /
 * popover plumbing and stays in lock-step with V2 as those evolve.
 *
 * CN-8312: V3 parity — Project Type dropdown, editable Stage, Appointment
 * Required, full update flow.
 */
@Component({
	selector: 'app-project-details-panel',
	templateUrl: './project-panel.component.html',
	styleUrls: [
		'../project-specifications/project-specifications.component.scss',
		'./project-panel.component.scss',
	],
	encapsulation: ViewEncapsulation.None,
})
export class ProjectDetailsPanelComponent extends ProjectSpecificationsComponent {}
